import React from "react";

const WhyKeratinHow = () => {
  return (
    <div className="blogBenefits-content">
      <h3>How Does Keratin Hair Treatment Work?</h3>
      <p>
        The primary function of{" "}
        <a href="https://scentlifestyle.com/why-you-should-consider-keratin-hair-treatment">
          {" "}
          keratin hair treatment
        </a>{" "}
        is to coat the hair shaft with a layer of protein that fills in any gaps
        or weak spots in the hair structure. When the keratin formula is applied
        to the hair, the heat from the flat iron helps it to bond with the hair
        cuticles. This creates a protective layer around the hair shaft, which
        not only smooths it but also protects it from future damage.
      </p>
      <p>Here’s a breakdown of the keratin treatment process:</p>
      <li>
        <h6>1. Preparation:</h6> The hair is washed with a clarifying shampoo to
        remove any product buildup, dirt, or oils. This ensures that the hair is
        clean and ready to absorb the keratin treatment.
      </li>
      <li>
        <h6>2. Application:</h6> The keratin treatment product is applied to
        damp hair section by section, ensuring full coverage from root to tip.
      </li>
      <li>
        <h6>3. Blow Drying:</h6> Once the product is applied, the hair is
        blow-dried to start the bonding process.
      </li>
      <li>
        <h6>4. Heat Sealing:</h6> A flat iron is used to straighten the hair and
        seal the keratin into the hair shaft. This step locks in the treatment,
        ensuring long-lasting results.
      </li>
      <li>
        <h6>5. Aftercare:</h6> Most keratin treatments require avoiding washing
        the hair for at least 48 hours after the procedure to allow the
        treatment to fully set.
      </li>
    </div>
  );
};

export default WhyKeratinHow;
